import { IColumnPk } from '../../../../webapi/index';
import { ColumnFieldType } from '../../enums/index';
import { ColumnFieldTypeObject } from '../ColumnFieldTypeObject';

export class ColumnRadioButtonDto<T extends IColumnPk = IColumnPk> extends ColumnFieldTypeObject {
  OnSelectedCallback: (dataDto: T) => void;
  GroupName: string;
  SelectedRowPk: string | undefined;

  constructor(init?: Partial<ColumnRadioButtonDto<T>>) {
    super();
    this.FieldType = ColumnFieldType.RadioButton;
    Object.assign(this, init);
  }
}
